define('recently_viewed_cell.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('recently_viewed_cell', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"recently-viewed-cell-item\"><div data-type=\"backbone.collection.view.cell\"></div></li>  ";
},"useData":true}, 'extensions/ES/MaxaMasterTheme/24.1.1/', 'extensions/ES/MaxaMasterTheme/24.1.1/', Handlebars);
});